import { Banner } from '@ingenico/react-ui/banner';
import { CloseModalButton } from '@ingenico/react-ui/confirmation-dialog';
import { CoreContainer } from '@ingenico/react-ui/core-container';
import { CoreStatus, StatusSize } from '@ingenico/react-ui/core-status';
import { DeviceChangesCallLogsSection } from '@ingenico/react-ui/device-changes-call-logs-section';
import { ParameterOutputSection } from '@ingenico/react-ui/parameter-output-section';
import { SideDrawer } from '@ingenico/react-ui/side-drawer';
import { Divider, LinearProgress } from '@mui/material';
import { useNavigate } from 'react-router';
import type { DeviceChangeDetailsDrawerProps } from './DeviceChangeDetailsDrawer.model';
import styles from './DeviceChangeDetailsDrawer.module.scss';
import { ALL_LNGS_NAMESPACES } from '@ingenico/util-i18n-config';
import { DeviceChangeDetailsPageContainer } from '../device-change-details-page-container/DeviceChangeDetailsPageContainer.ctrl';

export function DeviceChangeDetailsDrawer({
  statusData,
  deviceChangesByIdQuery,
  targetDeviceGeneralItems,
  targetDeviceIdItem,
  errorMessage,
  t,
  deviceCallLogs,
  isDeviceCallLogsLoading,
  canShowParameterOutputSection,
}: DeviceChangeDetailsDrawerProps) {
  const navigate = useNavigate();
  return (
    <SideDrawer
      customDrawerHeader={styles.customDrawerHeader}
      customDrawerHeaderWrapper={styles.customDrawerHeaderWrapper}
      open
      isLoadingSubtitle={deviceChangesByIdQuery?.isLoading}
      subtitle={<CoreStatus size={StatusSize.Medium} label={t(statusData?.labelKey)} status={statusData?.status} />}
      title={deviceChangesByIdQuery?.isLoading ? '' : deviceChangesByIdQuery?.data?.name}
      titleActions={<CloseModalButton onClick={() => void navigate('..')} />}
    >
      {deviceChangesByIdQuery?.isError && (
        <CoreContainer>
          <Banner message={errorMessage ?? t('error.default', { ns: ALL_LNGS_NAMESPACES.COMMON })} />
        </CoreContainer>
      )}
      {(deviceChangesByIdQuery?.isLoading || isDeviceCallLogsLoading) && <LinearProgress />}
      <div className={styles.contentContainer}>
        {!deviceChangesByIdQuery?.isLoading && !isDeviceCallLogsLoading && deviceChangesByIdQuery?.data ? (
          <DeviceChangeDetailsPageContainer
            targetDeviceIdItem={targetDeviceIdItem}
            targetDeviceGeneralItems={targetDeviceGeneralItems}
            errorMessage={errorMessage}
          />
        ) : undefined}
        {!deviceChangesByIdQuery?.isLoading && !isDeviceCallLogsLoading && canShowParameterOutputSection ? (
          <>
            <div className={styles.separatorContainer}>
              <Divider className={styles.separator} />
            </div>
            <ParameterOutputSection i18nNamespace={ALL_LNGS_NAMESPACES.CALL_LOGS} />
          </>
        ) : undefined}
        {!isDeviceCallLogsLoading && !!deviceCallLogs?.length ? (
          <>
            <div className={styles.separatorContainer}>
              <Divider className={styles.separator} />
            </div>
            <DeviceChangesCallLogsSection logs={deviceCallLogs} />
          </>
        ) : undefined}
      </div>
    </SideDrawer>
  );
}
